import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ContactPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const services = [
        "Home Loan ",
        "Commercial Loan ",
        "Industrial Loan ",
        "Mortgage Loan ",
        "Business Loan ",
        "Balance Transfer ",
        "Construction Funding ",
        "Education Loan ",
        "Commercial Vehicle Loans ",
        "Car Loan ",
        "Personal Loan ",
        "Property Search ",
        "ReDevelopment consultancy ",
        "Sole selling agent of entire project ",
        "Life Insurance ",
        "General Insurance ",
        "Mutual Funds ",
        "Property Exhibition ",
        "Property Insurance ",
        "Health Insurance ",
        "Vehicle Insurance ",
        "Loan Against Securities "
    ];

    const [formData,setFormData]=useState({
        name:"",
        mobile:"",
        email:"",
        serviceType:"",
        message:""
    })

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "mobile") {
            // Remove country code if pasted (+91 or 91)
            value = value.replace(/^\+?91/, "");
    
            // Remove leading zeros
            value = value.replace(/^0+/, "");
    
            // Remove spaces
            value = value.replace(/\s/g, "");
    
            // Only keep numeric values
            value = value.replace(/\D/g, "");
    
            // Limit to 10 digits
            value = value.slice(0, 10);
        }

        // if (name === "borrowAmount" || name === "monthlySalary") {
        //     value = value.replace(/\D/g, ""); // Remove non-numeric characters
        //     value = formatINR(value); // Format with INR commas
        // }

        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Show loader
        try {
            const response = await fetch(`https://100billionrealestate.com/contact`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    mobile: formData.mobile,
                    serviceType: formData.serviceType,
                    message: formData.message
                })
            })
            const res = await response.json();
            if (response.ok) {
                toast.success("Details sent, Our team will contact you soon", {
                    position: "top-center",
                    autoClose: 3000
                })
                setFormData({
                    name:"",
                    mobile:"",
                    email:"",
                    serviceType:"",
                    message:""
                })
                setLoading(false);
            }
            setLoading(false);
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 3000
            })
            setLoading(false);
        }
        // Simulate an API request (replace with actual API call)

    };
    return (
        <>
            <div className="other-pages-main-section contact-page-fin">
                <h2 className="other-pages-title">Contact Us</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/contact-loan-experts")} style={{ cursor: "pointer" }}>Contact</span>
                </p>
            </div>
            <section className="contact-page-smco">
                <div className="contact-page-smco-container">
                    <div className="contact-page-smco-left">
                        <h3>Contact Us</h3>
                        <form onSubmit={handleSubmit}>
                            <label>Name</label>
                            <input type="text" name="name" value={formData.name} className="contact-page-smco-input" onChange={handleChange} placeholder="Your Name" />

                            <label>Phone Number</label>
                            <input type="text" name="mobile" value={formData.mobile} className="contact-page-smco-input" placeholder="Your Number" onChange={handleChange}/>

                            <label>Email</label>
                            <input type="email" name="email" value={formData.email} className="contact-page-smco-input" placeholder="Your Email" onChange={handleChange}/>

                            <label>Service Type</label>
                            <select className="contact-page-smco-input" name="serviceType" value={formData.serviceType} onChange={handleChange}>
                                <option value="">Select Service</option>
                                {services.map((service, index) => (
                                    <option key={index} value={service}>{service}</option>
                                ))}
                            </select>

                            <label>Message</label>
                            <textarea className="contact-page-smco-input" placeholder="Your Message" name="message" value={formData.message} onChange={handleChange}></textarea>

                            <button type="submit" className="contact-page-smco-button">
                            {loading ? <span className="spinner"></span> : "Submit"}
                            </button>
                        </form>
                    </div>
                    <div className="contact-page-smco-right">
                        <h3>Office Information</h3>
                        <p><strong>Office Timing:</strong> 10:00 AM - 9:00 PM</p>
                        <p><strong>Address:</strong> Unit No. 2, A Wing , 4th Floor, Innov8 Time Square Building , Andheri Kurla Road, Andheri East, Mumbai - 400059
 </p>
                        <p><strong>Phone:</strong> +91-9930062311, +91 9136007212</p>
                        <p><strong>Email:</strong> info@magnifyadvisory.com</p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactPage;
